


























































































































import { Component, Prop, Emit } from "vue-property-decorator";
import Vue from "vue";
import DataObject from "@/utility/DataObject";
// import CardModalPemeriksaan from "../components/modal/CardModalPemeriksaan.vue";
import DateFormat from "@/utility/DateFormat";
import { SoapResponseItem } from "@/types/soap";

@Component({
  components: {
    // CardModalPemeriksaan
  }
})
export default class CardPemeriksaanPerawat extends Vue {
  @Prop() soap: SoapResponseItem;
  @Prop() modeCopy: boolean;
  btnS = false;
  btnO = false;
  btnA = false;
  btnP = false;

  mounted() {}

  modalOpen = false;
  // dt = this.soap
  selectS() {
    this.btnS = true;
  }
  unSelectS() {
    this.btnS = false;
  }
  selectO() {
    this.btnO = true;
  }
  unSelectO() {
    this.btnO = false;
  }
  selectA() {
    this.btnA = true;
  }
  unSelectA() {
    this.btnA = false;
  }
  selectP() {
    this.btnP = true;
  }
  unSelectP() {
    this.btnP = false;
  }
  copyS() {
    this.$emit("copyS", this.soap["s"]);
  }
  copyO() {
    this.$emit("copyO", this.soap["o"]);
  }
  copyA() {
    this.$emit("copyA", this.soap["a"]);
  }
  copyP() {
    this.$emit("copyP", this.soap["p"]);
  }

  pemeriksaanPerawat(item) {
    this.soap = item;
    this.modalOpen = true;
    // console.log(item)
  }
  formatTgl(tgl) {
    return DateFormat.formatDate(tgl);
  }
}
